const emails = {
  billing: 'billing@tiledb.com',
};

export default emails;
